import { render, staticRenderFns } from "./StatisticsTable.htm?vue&type=template&id=19494e50&scoped=true&"
import script from "./StatisticsTable.ts?vue&type=script&lang=js&"
export * from "./StatisticsTable.ts?vue&type=script&lang=js&"
import style0 from "./StatisticsTable.scss?vue&type=style&index=0&id=19494e50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19494e50",
  null
  
)

export default component.exports